import { OnInit, Component } from '@angular/core';
import { ReporteCompensaciones } from 'src/app/models/reporteCompensaciones.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { UrlService } from 'src/app/shared/services/url.service';
import { GlobalService } from 'src/app/shared/global.service';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { SolicitudAjuste } from 'src/app/models/solicitudAjuste.model';

@Component({
    selector: 'app-reporte-compensaciones',
    templateUrl: './reporte-compensaciones.component.html',
    styleUrls: ['./reporte-compensaciones.component.scss']
})

export class ReporteCompensacionesComponent implements OnInit {

    public consultaCompensaciones: ReporteCompensaciones[];
    public filtroNombre: string;
    public filtroNombreABuscar: string;
    public tipoIdFuncionario: string;
    public numeroIdFuncionario: string;
    public datosArchivo: any;
    public habilitarExportar: boolean;
    public habilitarNotificacion: boolean;
    public p: any;
    solicitudSeleccionada: SolicitudAjuste;

    constructor(
        private spinner: NgxSpinnerService,
        private urlService: UrlService,
        private global: GlobalService,
        private alertService: AlertService
    ) {
        this.solicitudSeleccionada = undefined;
        this.consultaCompensaciones = [];
        this.filtroNombre = undefined;
        this.habilitarExportar = false;
        this.habilitarNotificacion = false;
    }

    ngOnInit() {
        this.tipoIdFuncionario = sessionStorage.getItem(ConstantesService.TIPO_DOC_SESSSION);
        this.numeroIdFuncionario = sessionStorage.getItem(ConstantesService.NUM_DOC_SESSSION);
        this.consultarCompensaciones();
    }

    /**
     * Metodo que consulta las compensaciones Existentes
     */
    consultarCompensaciones() {
        this.filtroNombreABuscar = this.filtroNombre;
        this.spinner.show();
        const serviceProvider = 'consultarCompensaciones';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['filtroNombre', this.filtroNombreABuscar]);
        queryParams.push(['tipoIdFuncionario', this.tipoIdFuncionario]);
        queryParams.push(['numeroIdFuncionario', this.numeroIdFuncionario]);
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, queryParams),
            this.urlService.hostAPI_FUNCIONARIOS);
        this.global.postGenerico(url).subscribe(
            data => {
                this.consultaCompensaciones = data;
                if (this.consultaCompensaciones.length > 0) {
                   this.habilitarExportar = false;
                   this.habilitarNotificacion = false;
                }
                this.spinner.hide();
            }, err => {
                if (err.status === 500) {
                    this.cathException(err.error.message);
                    this.habilitarExportar = true;
                    this.habilitarNotificacion = true;
                    this.consultaCompensaciones.length = 0;
                } else {
                    this.cathException('No es posible consultar las compensaciones');
                }
            }
        );
    }

    /**
     * Metodo exportar Excel la compensaciones
     */
    ExportarCompensaciones() {
        this.spinner.show();
        const serviceProvider = 'exportarCompensaciones';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['filtroNombre', this.filtroNombreABuscar]);
        queryParams.push(['tipoIdFuncionario', this.tipoIdFuncionario]);
        queryParams.push(['numeroIdFuncionario', this.numeroIdFuncionario]);
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, queryParams),
            this.urlService.hostAPI_FUNCIONARIOS);
        this.global.postGenerico(url).subscribe(
            data => {
                this.datosArchivo = data;
                this.alertService.generateAlertSuccess('Su reporte se está descargando', '');
                this.descargarArchivo();
            }, err => {
                this.cathException('No es posible exportar las compensaciones');
            }
        );
    }

    /**
     * Metodo que notifica a Talento Humano
     */
    NotificarTalentoHumano() {
        this.spinner.show();
        const serviceProvider = 'notificarCompensaciones';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['filtroNombre', this.filtroNombreABuscar]);
        queryParams.push(['tipoIdFuncionario', this.tipoIdFuncionario]);
        queryParams.push(['numeroIdFuncionario', this.numeroIdFuncionario]);
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, queryParams),
            this.urlService.hostAPI_FUNCIONARIOS);
        this.global.postGenerico(url).subscribe(
            data => {
                this.alertService.generateAlertSuccess(data, 'Exitoso');
                this.spinner.hide();
            }, err => {
                if (err.status === 200) {
                    if (err.error.text === 'La notificación a Talento Humano fue Exitoso') {
                        this.alertService.generateAlertSuccess(err.error.text, 'Exitoso');
                        this.spinner.hide();
                    }
                    if (err.status === 500) {
                        this.cathException(err.error.message);
                    }
                } else {
                    this.cathException('No es posible notificar a Talento Humano');
                }
            }
        );
    }

    /**
     * Metodo que realiza el llamado para el detalle de la compensacion
     * @param compensacion Compensacion seleccionada
     */
    verDetalle(compensacion: ReporteCompensaciones) {
        this.solicitudSeleccionada = new SolicitudAjuste();
        this.solicitudSeleccionada.tipoIdFuncionario = compensacion.tipoDocumento;
        this.solicitudSeleccionada.numeroIdFuncionario = compensacion.documentoFuncionario;
    }

    refrescar() {
        this.solicitudSeleccionada = undefined;
    }

    /**
     * Método que convierte el archivo Excel y realiza la descarga del mismo
     */
    descargarArchivo() {
        ConstantesService.descargarDocumento('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            , this.datosArchivo.nombre, this.datosArchivo.archivo);
        this.spinner.hide();
    }

    /**
     * Método de control de Excepciones
     * @param error mensaje saliente respecto al error ocurrido
     */
    cathException(error) {
        this.alertService.generateAlertError(error, 'Error');
        this.spinner.hide();
    }

}
